import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectProgramType = createSelector(
  [selectConfigurationState],
  ({ programType }) => programType
)
